import { useQuery } from '@tanstack/react-query'
import { baseURL } from '@/v2/constants/requests'

export const useTreatments = patientId => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['Treatments', `${patientId}`],
    queryFn: async () => {
      const res = await fetch(
        `${baseURL}/v2/rest/patients/${patientId}/treatments.json`
      )
      if (!res.ok) {
        throw new Error("We couldn't find the patient treatments")
      }
      const result = await res.json()

      return result
    },
    enabled: !!patientId,
  })

  return { treatments: data, isLoading, isError }
}
